<template>
  <div>
    <p class="headerstyle">ข้อมูลของแอดมิน</p>

    <div class="fromstyle">
      <form @submit.prevent="checkForm">
        <div class="flex justify-center h-full">
          <Profile
            @Get-imgUrl="GetimgUrl"
            :img="imgUrl"
            class="Profile-style"
          />
        </div>

        <br />
        <p v-show="!imgUrl" class="headerstyle">ใส่รูปแอดมิน</p>
        <vs-input
          class="w-full"
          id="FirstName"
          placeholder="ชื่อ"
          type="text"
          v-model="FirstName"
          name="FirstName"
          disabled
        />
        <br />
        <vs-input
          class="w-full"
          id="LastName"
          placeholder="นามสกุล"
          type="text"
          v-model="LastName"
          name="LastName"
          disabled
        />
        <br />
        <vs-input
          class="w-full"
          id="email"
          placeholder="อีเมล"
          type="email"
          v-model="email"
          name="email"
          disabled
        />
        <br />
        <vs-input
          class="w-full"
          id="phone"
          placeholder="เบอร์ติดต่อ"
          type="Tel"
          v-model="phone"
          name="phone"
          disabled
        />
        <br />

        <select
          class="mb-5 custom-select"
          v-model="admintype"
          id="admintype"
          name="admintype"
          disabled
        >
          <option value="null" disabled selected>ตำแหน่ง</option>
          <option>super admin</option>
          <option>administrator</option>
        </select>
        <vs-row vs-w="12">
          <vs-col vs-w="12" class="flex justify-center"> </vs-col>
        </vs-row>
      </form>
    </div>
  </div>
</template>

<script>
import Profile from "@/views/elements/Profiletemplete.vue";
import axios from "../../../util/backend";
import baseUrl from "../../../util/baseUrl";
import { mapGetters } from "vuex";
export default {
  async mounted() {
    await this.Syncdata();
  },
  computed: {
    ...mapGetters({
      data: "general/editPage"
    })
  },

  components: {
    Profile
  },
  data() {
    return {
      FirstName: null,
      LastName: null,
      email: null,
      admintype: null,
      password: null,
      confirm_password: null,
      imgUrl: null,
      errors: [],
      phone: null,
      ShowPassword: false,
      Type: "password"
    };
  },
  methods: {
    async checkForm(e) {
      this.errors = [];
      if (this.password !== this.confirm_password) {
        this.errors.push("ยืนยันรหัสผ่านไม่ถูต้อง");
      }
      if (this.errors.length > 0) {
        for (const err of this.errors) {
          this.$vs.notify({
            title: "Error message",
            text: err,
            color: "danger",
            icon: "error",
            position: "top-right"
          });
        }
        return;
      }
      if (this.errors.length == 0) {
        this.$vs.loading();
        let config = {
          method: "post",
          url: `${baseUrl.baseurl()}/editAdmin`,
          data: {
            first_name: this.FirstName.trimLeft(),
            last_name: this.LastName.trimLeft(),
            email: this.email,
            password: this.password,
            phone: this.phone,
            role: this.admintype,
            img_url: this.imgUrl ? this.imgUrl : null
          }
        };
        await axios
          .api(config)
          .then(res => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "การสร้างแอดมิน",
              text: "สำเร็จ",
              color: "success",
              icon: "check_box",
              position: "top-right"
            });
            this.$router.push({ path: "/administrator" });
          })
          .catch(err => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Error message",
              text: `${
                err.response.data.error ? err.response.data.error : err
              }`,
              color: "danger",
              icon: "error",
              position: "top-right"
            });
          });
      }
    },
    GetimgUrl(e) {
      this.imgUrl = e;
    },

    ToggleShowPassword() {
      if (this.ShowPassword) {
        this.Type = "password";
        this.ShowPassword = !this.ShowPassword;
      } else {
        this.Type = "text";
        this.ShowPassword = !this.ShowPassword;
      }
    },
    Syncdata() {
      this.FirstName = this.data.first_name;
      this.LastName = this.data.last_name;
      this.phone = this.data.phone;
      this.email = this.data.email;
      this.admintype = this.data.role;
      this.imgUrl = this.data.img_url;
    }
  }
};
</script>

<style lang="scss" scoped>
.headerstyle {
  color: #1a3683;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 600;
  text-align: center;
}

.share-btn {
  background-color: #0430ad;
  padding: 10px 20px 10px 20px;
  border-radius: 10px;
  border-style: none;
  color: #ffff;

  &:hover {
    transition-delay: 100ms;
    background-color: #072c49;
  }
  &:active {
    background-color: #072c49;
  }
}
.Profile-style {
  height: 10rem;
  width: 10rem;
}
</style>
